import { CustomInputCurrency as InputCurrency } from '../../../../components/CustomInputCurrency';
import { CustomInputNumber as InputNumber } from '../../../../components/CustomInputNumber';
import { CustomSelectPicker as SelectPicker } from '../../../../components/CustomSelectPicker';
import { Label } from '../../../../components/Label';
import { Flex } from '../../../../components/Flex/Flex';
import { cashbackModoKeys, loyaltyTypesKeys, selectCashbackModoData } from '../../constants';

export const ConditionSection = ({ form, onChange }) => {
  const isCashback = form.type === loyaltyTypesKeys.cashback;
  const isPedidos = form.type === loyaltyTypesKeys.pedidos;
  const isValorAcumulado = form.type === loyaltyTypesKeys.valor_acumulado;

  if (isCashback) {
    return (
      <Flex column>
        <div>
          <Label>Como o cashback é calculado</Label>
          <SelectPicker
            style={{ width: '100%' }}
            data={selectCashbackModoData}
            value={form.cashbackModo}
            placeholder="Selecione a regra do cashback"
            searchable={false}
            onSelect={onChange('cashbackModo')}
          />
        </div>

        {form.cashbackModo === cashbackModoKeys.por_pedido && (
          <InputCurrency
            placeholder="R$ 0,00"
            label="Valor de cashback por pedido"
            value={form.cashbackFixedValue}
            onChange={onChange('cashbackFixedValue')}
          />
        )}

        {form.cashbackModo === cashbackModoKeys.percentual && (
          <InputNumber
            placeholder="Ex: 10"
            label="Percentual do valor gasto (%)"
            value={form.cashbackPercentage}
            onChange={onChange('cashbackPercentage')}
          />
        )}

        {form.cashbackModo === cashbackModoKeys.meta_valor && (
          <Flex>
            <InputCurrency
              placeholder="R$ 0,00"
              label="Valor necessário em compras"
              value={form.cashbackGoalValue}
              onChange={onChange('cashbackGoalValue')}
            />
            <InputCurrency
              placeholder="R$ 0,00"
              label="Cashback ao atingir a meta"
              value={form.cashbackFixedValue}
              onChange={onChange('cashbackFixedValue')}
            />
          </Flex>
        )}
      </Flex>
    );
  }

  if (isPedidos) {
    return (
      <InputNumber
        placeholder="Ex: 10"
        label="Quantidade de pedidos necessária (selos)"
        value={form.goalQuantity}
        onChange={onChange('goalQuantity')}
      />
    );
  }

  if (isValorAcumulado) {
    return (
      <InputCurrency
        placeholder="R$ 0,00"
        label="Valor necessário em compras"
        value={form.goalValue}
        onChange={onChange('goalValue')}
      />
    );
  }

  return null;
};
